import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth } from '@/components/guards/RequireAuth';
import { RequireCapability } from '@/components/guards/RequireCapability';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { TicketsListPage } from '@/pages/TicketsListPage';
import { TicketDetailPage } from '@/pages/TicketDetailPage';
import { NewTicketPage } from '@/pages/NewTicketPage';
import { MyQueuePage } from '@/pages/MyQueuePage';
import { MyTagsPage } from '@/pages/MyTagsPage';
import { ApprovalsPage } from '@/pages/ApprovalsPage';
import { UsersPage } from '@/pages/UsersPage';
import { ArchivesPage } from '@/pages/ArchivesPage';
import { DeletedPage } from '@/pages/DeletedPage';
import { PermissionsPage } from '@/pages/PermissionsPage';
import { ShopifyPage } from '@/pages/ShopifyPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { StoragePage } from '@/pages/StoragePage';
import { ApiPage } from '@/pages/ApiPage';
import { CategoryGroupPage } from '@/pages/CategoryGroupPage';
import { ChangePinPage } from '@/pages/ChangePinPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/tickets" element={<TicketsListPage />} />
        <Route path="/tickets/new" element={<NewTicketPage />} />
        <Route path="/tickets/:id" element={<TicketDetailPage />} />
        <Route path="/my-queue" element={<MyQueuePage />} />
        {/* V4.9.25 — category-group dashboards (new sidebar tabs). */}
        <Route path="/refund" element={<CategoryGroupPage groupKey="refund" />} />
        <Route path="/reprint-replacement" element={<CategoryGroupPage groupKey="reprint-replacement" />} />
        <Route path="/other-issues" element={<CategoryGroupPage groupKey="other-issues" />} />
        <Route path="/request" element={<CategoryGroupPage groupKey="request" />} />
        <Route path="/my-tags" element={<MyTagsPage />} />
        <Route
          path="/approvals"
          element={
            <RequireCapability capability="approvals.view">
              <ApprovalsPage />
            </RequireCapability>
          }
        />
        <Route
          path="/users"
          element={
            <RequireCapability capability="users.view">
              <UsersPage />
            </RequireCapability>
          }
        />
        <Route
          path="/archives"
          element={
            <RequireCapability capability="tickets.view_archived">
              <ArchivesPage />
            </RequireCapability>
          }
        />
        <Route
          path="/deleted"
          element={
            <RequireCapability capability="tickets.view_deleted">
              <DeletedPage />
            </RequireCapability>
          }
        />
        <Route
          path="/permissions"
          element={
            <RequireCapability capability="permissions.manage">
              <PermissionsPage />
            </RequireCapability>
          }
        />
        <Route
          path="/shopify"
          element={
            <RequireCapability capability="shopify.view">
              <ShopifyPage />
            </RequireCapability>
          }
        />
        {/* V4.9.10 — Admin Reports module (refund / reprint analytics, fault tracking, CSV export). */}
        <Route
          path="/reports"
          element={
            <RequireCapability capability="reports.view">
              <ReportsPage />
            </RequireCapability>
          }
        />
        {/* V4.9.20 — Admin Storage (Google Drive offload). Admin-only: the page
            redirects non-admins and the backend enforces it. */}
        <Route path="/storage" element={<StoragePage />} />
        <Route path="/sheets-api" element={<ApiPage />} />
        <Route path="/change-pin" element={<ChangePinPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
